import getConfig from 'next/config';

import {getData, setData} from '~/src/utilities/helpers/context';
import {login} from '~/src/utilities/helpers/account';
import {refreshOrShouldLogin} from '~/src/utilities/helpers/login';
import {trackEvent} from '~/src/utilities/tracking/beagle';
import {getApiRequest, postApiRequest, deleteApiRequest} from '~/src/utilities/feed/api';
import {BeagleEvents} from '~/src/utilities/constants/tracking';
import {TeaserTypes, ContentType} from '~/src/utilities/constants/types';
import {Logger} from '~/src/utilities/helpers/log';

const {publicRuntimeConfig: config} = getConfig();

const getBookmarks = async () => {
    try {
        if (await refreshOrShouldLogin(true)) {
            return login();
        }

        const envelope = await getApiRequest(config.feeds.bookmarks, true);
        const bookmarks = await envelope.getData();

        setData({bookmarks});

        return getData().bookmarks;
    } catch (error) {
        Logger.info(`[${error.name}][bookmark]: error while fetching bookmarks`, {error});
    }
};

const addBookmark = async (metadataId, type) => {
    const data = {
        data: {
            type: 'bookmark',
            attributes: {
                content: {
                    metadataID: metadataId.toString(),
                    tenantID: config.tenantId.toString(),
                    type: 'content'
                }
            }
        }
    };

    const beagleEvent = type === TeaserTypes.VIDEOS || type === ContentType.VIDEO ? BeagleEvents.VIDEO_BOOKMARK : BeagleEvents.STORY_BOOKMARK;
    trackEvent(beagleEvent, {resourceId: metadataId, value: '+1'});
    try {
        const envelope = await postApiRequest(config.feeds.bookmarks, data, true);
        const bookmark = await envelope.getData();
        const bookmarks = getData().bookmarks;
        setData({bookmarks: [...bookmarks, bookmark]});
    } catch (error) {
        Logger.info(`[${error.name}][bookmark]: error while adding bookmark`, {error});
    }
};

const removeBookmark = async (metadataId, type) => {
    const bookmarks = getData().bookmarks;
    const bookmark = bookmarks.find((bookmark) => bookmark.content.id === metadataId.toString());

    const beagleEvent = type === TeaserTypes.VIDEOS || type === ContentType.VIDEO ? BeagleEvents.VIDEO_BOOKMARK : BeagleEvents.STORY_BOOKMARK;
    trackEvent(beagleEvent, {resourceId: metadataId, value: '-1'});
    if (bookmark) {
        try {
            await deleteApiRequest(`${config.feeds.bookmarks}/${bookmark.id}`);
            setData({bookmarks: bookmarks.filter((bookmark) => bookmark.content.id !== metadataId.toString())});
        } catch (error) {
            Logger.info(`[${error.name}][bookmark]: error while removing bookmark`, {error});
        }
    }
};

export {getBookmarks, addBookmark, removeBookmark};
